import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'sb-please-wait-modal',
  templateUrl: './please-wait-modal.component.html',
  styleUrls: ['./please-wait-modal.component.scss'],
  standalone: false
})
export class PleaseWaitModalComponent {
  // Must be a key that exists in the org labels; unknown keys render as the raw key.
   // Legacy pleaseWaitModal default message was 'SB_Saving_changes_please_wait'.
  @Input() message = 'SB_Saving_changes_please_wait';

  constructor(public activeModal: NgbActiveModal) {}
}
